<template>
  <div>
    <el-form :model="form" label-position="right" label-width="150px" size="mini">
      <el-form-item v-if="isProgramsArtifactSelectEnabled" label="选择程序更新包：">
        <el-select v-model="form.selectedArtifacts['programs']" clearable
          placeholder="点击右侧的刷新按钮可获取更新包列表，如不需更新程序请勿选择程序更新包" style="width: 500px">
          <el-option v-for="item in form.artifactSelectorOptions['programs']" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="onClickQueryArtifactsBtn('programs')"
          :loading="form.isQueryingArtifacts['programs']" style="margin-left: 10px">刷新</el-button>
      </el-form-item>

      <el-form-item label="选择excel更新包：">
        <el-select v-model="form.selectedArtifacts['excels']" clearable
          :placeholder="isProgramsArtifactSelectEnabled ? '点击右侧的刷新按钮可获取更新包列表，如不需更新excel请勿选择excel更新包' : '点击右侧的刷新按钮可获取更新包列表'"
          style="width: 500px">
          <el-option v-for="item in form.artifactSelectorOptions['excels']" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="onClickQueryArtifactsBtn('excels')"
          :loading="form.isQueryingArtifacts['excels']" style="margin-left: 10px">刷新</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onClickUpdateBtn()">开始更新</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      // 是否允许选择程序更新包（目前仅管理员角色能够选择程序更新包）
      isProgramsArtifactSelectEnabled: bizutil.getLoginUserRole() == "管理员",

      form: {
        artifactSelectorOptions: {
          "excels": [],
          "programs": [],
        },
        selectedArtifacts: {
          "excels": "",
          "programs": "",
        },
        isQueryingArtifacts: {
          "excels": false,
          "programs": false,
        },
      },
    }
  },

  methods: {
    /**
     * 点击了镜像集合查询按钮
     * 
     * @param artifactType 镜像类型     
     */
    async onClickQueryArtifactsBtn(artifactType) {
      this.form.isQueryingArtifacts.artifactType = true;
      this.form.artifactSelectorOptions[artifactType] = [];
      let newOptions = [];

      let queriedArtifacts = await this.queryArtifactList(artifactType);

      for (let a of queriedArtifacts) {
        let tag = ""
        let colonPos = a.artifact.lastIndexOf(":");
        if (colonPos >= 0) {
          tag = a.artifact.substr(1 + colonPos);
        }

        let sizeStr = `${(Number(a.size) / 1048576).toFixed(2)}MB`;
        let label = `${tag}（${sizeStr}）`;

        newOptions.push({
          label: label,
          value: a.artifact,
        });
      }

      this.form.artifactSelectorOptions[artifactType] = newOptions;

      // 自动选择第一个镜像
      if (this.form.artifactSelectorOptions[artifactType].length > 0) {
        this.form.selectedArtifacts[artifactType] = this.form.artifactSelectorOptions[artifactType][0].value;
      }

      this.form.isQueryingArtifacts.artifactType = false;
    },

    /**
     * 查询镜像集合
     * 
     * @param artifactType 镜像类型
     * @param limit 让服务器返回几个（可以不填）
     */
    async queryArtifactList(artifactType, limit) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryArtifactList`,
          {
            artifactType: artifactType,
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      return resData.data.artifacts;
    },

    /**
     * 点击了更新按钮
     */
    async onClickUpdateBtn() {
      let selectedArtifacts = [];

      for (let artifactType of Object.keys(this.form.selectedArtifacts)) {
        let artifact = this.form.selectedArtifacts[artifactType];
        if (artifact != "") {
          selectedArtifacts.push({
            type: artifactType,
            artifact: artifact,
          })
        }
      }

      if (selectedArtifacts.length == 0) {
        this.$alert("请至少选择一个更新包", "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageServerUpdateJobs`,
          {
            action: "create",
            create: {
              artifacts: selectedArtifacts,
            }
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      this.$alert("已开始更新，请等待更新完成", "提示", {
        center: true,
        type: "success",
        confirmButtonText: "查看更新进度",
        callback: (action) => {
          // 向父级页面请求将tab切到“更新历史”
          this.$emit("requestToSwitchTab", "updateHistories");
        },
      });
    },
  }
}
</script>